// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"TableHeader_tableHeader__3hXD4","incomeHeader":"TableHeader_incomeHeader__JA8EH"};